import { Component, Fragment, h } from 'preact';
import { SubtitlesTemplateProps, SubtitlesTemplateState } from '../types';
import './subtitles.scss';

export class SubtitlesTemplate extends Component<SubtitlesTemplateProps, SubtitlesTemplateState> {
  constructor(props: SubtitlesTemplateProps) {
    super(props);
    this.state = {
      currentSubtitle: this.props.currentSubtitle?.split('<br />'),
      previousSubtitle: [],
      showPrevCaption: true,
      showNextCaption: false
    };
    setTimeout(() => {
      this.setState({ showPrevCaption: false, showNextCaption: true });
    }, 50);
  }

  componentWillUpdate(nextProps: Readonly<SubtitlesTemplateProps>): void {
    const { currentSubtitle } = nextProps;
    if (currentSubtitle !== this.props.currentSubtitle) {
      this.setState({
        previousSubtitle: this.props.currentSubtitle?.split('<br />'),
        currentSubtitle: currentSubtitle?.split('<br />'),
        showPrevCaption: true,
        showNextCaption: false
      });
      setTimeout(() => {
        this.setState({ showPrevCaption: false, showNextCaption: true });
      }, 50);
    }
  }

  render() {
    const { previousSubtitle, currentSubtitle, showPrevCaption, showNextCaption } = this.state;
    return (
      <Fragment>
        <div
          className={`str-title str-caption-container str-prev-caption ${
            showPrevCaption ? '' : 'str-caption-scroll-up'
          }`}
        >
          {previousSubtitle?.map((subtitle) => {
            return <span>{subtitle}</span>;
          })}
        </div>
        <div
          className={`str-title str-caption-container str-current-caption ${
            showNextCaption ? 'str-caption-show' : 'str-caption-bottom'
          }`}
        >
          {currentSubtitle?.map((subtitle) => {
            return <span>{subtitle}</span>;
          })}
        </div>
      </Fragment>
    );
  }
}
